import { useIntl } from "react-intl";

import { BlueWaveLayoutJSM } from "@/components/signup/layouts";

export const LoggedOutJiraServiceManagementStandard = () => {
    const { formatMessage } = useIntl();
    return (
        <BlueWaveLayoutJSM
            productEditionText={formatMessage({
                id: "WacSignupHeader.cloudStandard",
                defaultMessage: "Cloud Standard"
            })}
        />
    );
};
